var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 303.21 303.21",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#2969B3;}\r\n\t.st2{fill:#222653;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n\t.st4{fill:#CDEAE8;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8.1379,8.1379;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.69,182c-3.96,1.69-11.3,3.68-20.85,5.47C198.49,185.49,206.35,183.38,208.69,182 C208.69,182,208.69,182,208.69,182z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.93,188.33c-15.18,2.52-34.77,4.39-54.89,3.97c0.02,0,0.04,0,0.07,0 C146.14,193.17,166.9,191.02,182.93,188.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.44,230.79c5.96-25.91,2.52-14.9,9.63-47.12c0,0,0.23-116.98,0-127.38c-1.76,13.45-7.26,81.02-9.4,96.61 c-2.14,15.59-5.5,59.01-9.48,75.52c-3.97,16.51-7.64,35.77-8.25,47.08c-0.61,11.31-0.61,14.68,4.28,20.79 c1,1.99,1.97,4.42,2.76,6.92h6.68C59.62,274.56,60.38,244.05,63.44,230.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.67,0c7.14,25.11,16.36,56.63,18.03,63.93c2.45,10.7,18.96,70.32,18.96,70.32s6.11,17.12,0,43.72 c-6.11,26.6-20.48,82.55-20.48,82.55l-8.78,42.69h43.45V0H255.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.35,303.21h2.36C138.63,300.31,137.66,299.31,137.35,303.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.99,187.81c0.36-0.06,0.73-0.13,1.08-0.19C186.72,187.68,186.36,187.74,185.99,187.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,156.26c1.53-14.06,3.67-49.22,4.28-62.98c0.61-13.76,0-38.22,0-48c0-7.48,0.36-30.86,3.4-45.28H3.64 v303.21h18.75c0.24-21.77,1.76-74.49,3.06-86.72C26.98,202.12,26.67,170.33,28.2,156.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.48,178.96c0,0,0.76-0.16,0.12,0.45c0.53,1.96,2.68,10.09,4.58,18.58c2.18,9.75,6.31,34.17,7.91,47.46 c1.32,10.96,3.26,28.45,4.42,45.94c6.61-12.62,15.3-29.5,15.3-29.5s0.76-38.06,0.76-49.68c0-11.62,2.45-52.28,5.81-57.48 c-2.45-9.17-28.74-102.42-28.74-102.42s-1.53-2.45-1.53,3.67c0,6.11-10.7,111.99-10.7,111.99s0.31,6.02,1.53,11.53 c0.04,0.17-0.01,0.35-0.13,0.54c0.38-0.27,0.63-0.47,0.79-0.62C212.52,179.13,212.48,178.96,212.48,178.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.18,188.29c0.51-0.09,1.01-0.17,1.51-0.26C184.19,188.12,183.69,188.21,183.18,188.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.09,245.46c-1.61-13.3-5.73-37.72-7.91-47.46c-1.9-8.48-4.05-16.61-4.58-18.58 c-0.16,0.16-0.41,0.35-0.79,0.62c-0.37,0.57-1.44,1.24-3.12,1.96c0,0,0,0-0.01,0c-2.34,1.37-10.2,3.49-20.84,5.46 c-0.25,0.05-0.51,0.1-0.77,0.14c-0.36,0.07-0.72,0.13-1.08,0.19c-0.43,0.08-0.86,0.15-1.3,0.23c-0.5,0.09-1,0.17-1.51,0.26 c-0.08,0.01-0.17,0.03-0.25,0.04c-16.03,2.69-36.79,4.83-54.82,3.98c-0.02,0-0.04,0-0.07,0c-18.93-0.39-38.32-2.81-54.97-8.64 c-7.11,32.22-3.67,21.21-9.63,47.12c-3.05,13.26-3.82,43.77-3.78,72.42h77.7c0.31-3.9,1.28-2.9,2.36,0h83.52 c1.28-2.3,3.61-6.7,6.29-11.81C228.36,273.91,226.41,256.42,225.09,245.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.48,178.96c0,0,0.04,0.16,0.12,0.45C213.24,178.81,212.48,178.96,212.48,178.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.66,177.97c6.11-26.6,0-43.72,0-43.72s-16.51-59.62-18.96-70.32c-1.67-7.3-10.89-38.82-18.03-63.93H35.88 c-3.04,14.42-3.4,37.8-3.4,45.28c0,9.78,0.61,34.24,0,48c-0.61,13.76-2.75,48.92-4.28,62.98c-1.53,14.06-1.22,45.86-2.75,60.23 c-1.3,12.23-2.82,64.95-3.06,86.72h30.58c-0.79-2.5-1.76-4.93-2.76-6.92c-4.89-6.11-4.89-9.48-4.28-20.79 c0.61-11.31,4.28-30.57,8.25-47.08c3.97-16.51,7.34-59.92,9.48-75.52c2.14-15.59,7.64-83.16,9.4-96.61 c0.23,10.39,0,127.38,0,127.38c16.65,5.83,36.05,8.25,54.97,8.64c20.12,0.42,39.71-1.45,54.89-3.97c0.08-0.01,0.17-0.03,0.25-0.04 c0.51-0.09,1.01-0.17,1.51-0.26c0.44-0.08,0.87-0.15,1.3-0.23c0.36-0.06,0.73-0.13,1.08-0.19c0.26-0.05,0.51-0.09,0.77-0.14 c9.55-1.78,16.89-3.77,20.85-5.47c1.68-0.72,2.75-1.39,3.12-1.96c0.12-0.19,0.17-0.37,0.13-0.54c-1.22-5.5-1.53-11.53-1.53-11.53 s10.7-105.88,10.7-111.99c0-6.11,1.53-3.67,1.53-3.67s26.29,93.25,28.74,102.42c-3.36,5.2-5.81,45.86-5.81,57.48 c0,11.62-0.76,49.68-0.76,49.68s-8.69,16.89-15.3,29.5c-2.68,5.12-5.01,9.51-6.29,11.81h40.17l8.78-42.69 C272.17,260.52,286.54,204.57,292.66,177.97z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M72.21,151.75c0,0,55.07,28.24,139.06-4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image3.496285dd6a37cf123837d7fd57ee36b4.svg";
export { ForwardRef as ReactComponent };